import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import type {Context} from 'src/common/types'
import type {DefaultVarProps} from './DefaultVar'
import {DefaultVar} from './DefaultVar'
import type {MultipleItemsVarProps} from './MultipleItemsVar'
import MultipleItemsVar from './MultipleItemsVar'
import type {V2Props} from './V2'
import HighlightsSectionV2 from './V2'
import type {WithoutIconsVarProps} from './WithoutIconsVar'
import WithoutIconsVar from './WithoutIconsVar'

/**
 * Props for `HighlightSection`.
 */
export type HighlightSectionProps = SliceComponentProps<Content.HighlightSectionSlice>

/**
 * Component for "HighlightSection" Slices.
 */
const HighlightSection = (props: HighlightSectionProps & {context: Context}): JSX.Element => {
  switch (props.slice.variation) {
    case 'multipleItems':
      return <MultipleItemsVar {...(props as MultipleItemsVarProps)} />
    case 'v2':
      return <HighlightsSectionV2 {...(props as V2Props & {context: Context})} />
    case 'withoutIcons':
      return <WithoutIconsVar {...(props as WithoutIconsVarProps)} />
    default:
      return <DefaultVar {...(props as DefaultVarProps)} />
  }
}

export default HighlightSection
